




























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ConfirmationData } from '@/types/types';
import { Button } from 'element-ui';
import get from 'lodash/get';

@Component({
  components: {
    'el-button': Button
  }
})
export default class ConfirmationModal extends Vue {
  private name = 'ConfirmationModal';
  private forceClose = false;

  @Prop() private confirmationData?: ConfirmationData;

  @Watch('confirmationData')
  private resetClose() {
    this.forceClose = false;
  }

  get isActive() {
    return !!(!this.forceClose && this.confirmationData);
  }

  get titleLabel() {
    return get(this.confirmationData, 'options.titleLabel', null);
  }

  get modalContent() {
    if (this.confirmationData && this.confirmationData.options) {
      return this.confirmationData.options.modalContent || null;
    }
  }

  get color() {
    return get(this.confirmationData, 'options.color', 'danger');
  }

  private close(): void {
    this.forceClose = true;
  }

  private confirm(): void {
    if (!this.confirmationData) {
      return;
    }

    if (this.confirmationData.mutation) {
      this.$store.commit(this.confirmationData.mutation, this.confirmationData.payload);
    }

    if (this.confirmationData.dispatch) {
      this.$store.dispatch(this.confirmationData.dispatch, this.confirmationData.payload);
    }

    this.forceClose = true;
  }
}
